import { render } from "./HelpIcon.vue?vue&type=template&id=6ca1871e"
import script from "./HelpIcon.vue?vue&type=script&lang=ts"
export * from "./HelpIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script